import { callBackURL, setDestinationUri, setEmail } from "../lib/helpers";
import { identifyApp } from "../lib/identify-app";

identifyApp();
setDestinationUri();
setEmail();

document.location = callBackURL("/auth/log_out_callback");
